import { createContext, useContext } from 'react';

/**
 * Tells the backend a 1:1 booking Zoom confirmed in its frame, by Zoom's booking id, so CareBetty
 * moves the member's consult to in-progress now rather than at care-hooks' next hourly sync.
 * Provided by the scheduling page, which holds the session; absent (a no-op) anywhere else.
 */
export type ReportBooking = (scheduledEventId: string) => void;

export const BookingReportContext = createContext<ReportBooking | null>(null);

export function useReportBooking(): ReportBooking | null {
  return useContext(BookingReportContext);
}
